<form [formGroup]="form">
  <app-select
    *ngIf="showSelect"
    [label]="showLabels ? label : ''"
    [alignRight]="alignRight"
    [control]="selectControl"
    [options]="addressOptionsObservable"
    [showAdd]="true"
    [showEdit]="selectControl.value"
    [addTitle]="'Nieuw adres toevoegen'"
    (onAdd)="onAdd()"
    (onEdit)="onEdit()"
    [hideSelectedOption]="true"
    [isReadOnly]="isReadOnly"
    [convertString]="false"
  >
  </app-select>
  <app-horizontal-wrapper *ngIf="showSelect && !showForm && selectControl.value" [label]="' '">
    <app-validator [type]="'custom'" [control]="form">
      <span
        >{{ name }} heeft onbrekende velden, klik op
        <a (click)="onEdit()">
          <i class="fa-solid fa-pencil text-danger btn-add"></i> om deze in te vullen
        </a>
      </span>
    </app-validator>
  </app-horizontal-wrapper>
  <div *ngIf="showForm && fields">
    <ng-container *ngFor="let addressType of fields">
      <app-horizontal-text-input
        *ngIf="addressType === 'VatNumber'"
        [id]="'VatNumber'"
        [control]="form.VatNumber"
        [type]="'vatnumber'"
        [alignRight]="showSelect || alignRight"
        [label]="showLabels ? 'Btw-nummer' : ''"
        [placeholder]="'BE ____.___.___'"
        [isLoading]="vatIsLoading"
        [isReadOnly]="isReadOnly"
        [noCols]="noCols"
      ></app-horizontal-text-input>
      <app-horizontal-text-input
        *ngIf="addressType === 'EnterpriseNumber'"
        [id]="'EnterpriseNumber'"
        [control]="form.EnterpriseNumber"
        [type]="'enterprisenumber'"
        [alignRight]="showSelect || alignRight"
        [label]="showLabels ? 'Ondernemingsnummer' : ''"
        [placeholder]="'____.___.___'"
        [isLoading]="vatIsLoading"
        [isReadOnly]="isReadOnly"
        [noCols]="noCols"
      ></app-horizontal-text-input>

      <app-horizontal-text-input
        *ngIf="
          (form.Id.value == 0 ||
            showNameOnEdit ||
            forceShowName ||
            form.model.Name == '' ||
            form.model.Name == null) &&
          addressType === 'Name'
        "
        [id]="'AddressName'"
        [control]="form.Name"
        [alignRight]="showSelect || alignRight"
        [label]="showLabels ? 'Benaming' : ''"
        [isReadOnly]="isReadOnly"
        [noCols]="noCols"
      ></app-horizontal-text-input>
      <app-horizontal-text-input
        *ngIf="addressType === 'Street'"
        [id]="'Street'"
        [control]="form.Street"
        [type]="'address'"
        [href]="getMapsUrl()"
        [alignRight]="showSelect || alignRight"
        [label]="showLabels ? 'Straat, nr. bus' : ''"
        [placeholder]="'Vergeet het huis- en busnummer niet'"
        [isReadOnly]="isReadOnly"
        [noCols]="noCols"
        (blur)="clearSuggestions()"
      ></app-horizontal-text-input>
      <div class="row {{ isReadOnly ? 'mb-0' : 'mb-3' }}" *ngIf="addressType === 'StreetNrBus'">
        <label
          *ngIf="showLabels"
          class="{{ noCols ? 'col-lg-12' : 'col-lg-4' }} col-form-label {{
            showSelect || alignRight ? 'text-lg-end' : ''
          }}"
          >Straat, nr, bus {{ form.Street | createRequiredString }}</label
        >
        <div class="col-lg-{{ showLabels ? (noCols ? '7' : '4') : '6' }} mb-3 mb-lg-0">
          <div class="input-group" *ngIf="!isReadOnly">
            <input
              id="Street1"
              class="form-control"
              type="text"
              placeholder="Straat"
              [formControl]="form.Street"
              (blur)="onStreetBlur()"
            />

            <span *ngIf="addressNotFound && form.Street.value" class="input-group-text">
              <a (click)="showAddressAlert()" title="Adres niet gevonden in adresregister">
                <i class="fa-solid fa-circle-exclamation text-warning me-2 warning"></i>
              </a>
            </span>
          </div>

          <span *ngIf="isReadOnly">{{ form.Street.value }}</span>
        </div>
        <div class="col-lg-{{ showLabels ? (noCols ? '3' : '2') : '3' }}">
          <input
            id="nr"
            class="form-control"
            type="text"
            placeholder="Huisnummer"
            [formControl]="form.Nr"
            *ngIf="!isReadOnly"
          />
          <span *ngIf="isReadOnly">{{ form.Nr.value }}</span>
        </div>
        <div class="col-lg-{{ showLabels ? '2' : '3' }}">
          <input
            id="bus"
            class="form-control"
            type="text"
            placeholder="Bus"
            [formControl]="form.Bus"
            *ngIf="!isReadOnly"
          />
          <span *ngIf="isReadOnly">{{ form.Bus.value }}</span>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          (addressType === 'Street' || addressType === 'StreetNrBus') &&
          suggestions &&
          suggestions.length > 0
        "
      >
        <label *ngIf="showLabels" class="col-lg-4 col-form-label text-lg-end"></label>
        <div class="col-lg-8">
          <datalist
            id="suggestions"
            style="padding-left: 11px; overflow: scroll; height: 305px !important"
          >
            <option
              *ngFor="let suggestion of suggestions"
              [value]="suggestion"
              (click)="selectSuggestion(suggestion)"
            >
              {{ suggestion }}
            </option>
          </datalist>
        </div>
      </div>
      <div class="row {{ isReadOnly ? 'mb-0' : 'mb-3' }}" *ngIf="addressType === 'Location'">
        <label
          *ngIf="showLabels"
          class="{{ noCols ? 'col-lg-12' : 'col-lg-4' }} col-form-label {{
            showSelect || alignRight ? 'text-lg-end' : ''
          }}"
          >Gemeente {{ form.PostCode | createRequiredString }}</label
        >
        <div
          class="col-lg-{{ showLabels ? (noCols ? '3' : '2') : '3' }} mb-3 mb-lg-0 {{
            isReadOnly ? 'py-2' : ''
          }}"
        >
          <input
            id="postcode"
            class="form-control"
            type="text"
            placeholder="Postcode"
            [formControl]="form.PostCode"
            *ngIf="!isReadOnly"
          />
          <span *ngIf="isReadOnly">{{ form.PostCode.value }}</span>
        </div>
        <div
          class="col-lg-{{ showLabels ? (noCols ? '9' : '6') : '9' }} {{
            isReadOnly ? 'py-2' : ''
          }}"
        >
          <input
            id="location"
            class="form-control"
            type="text"
            placeholder="Gemeente"
            [formControl]="form.Location"
            *ngIf="!isReadOnly"
            (blur)="clearSuggestionsPost()"
          />
          <span *ngIf="isReadOnly">{{ form.Location.value }}</span>
          <div class="row" *ngIf="suggestionsPost && suggestionsPost.length > 0">
            <div class="col-lg-12 mt-3">
              <datalist id="suggestionsPost" style="padding-left: 11px">
                <option
                  (click)="selectPost(suggestion)"
                  *ngFor="let suggestion of suggestionsPost"
                  [value]="suggestion"
                >
                  {{ suggestion.name }}
                </option>
              </datalist>
            </div>
          </div>
        </div>
      </div>
      <app-select
        *ngIf="addressType === 'Country'"
        [id]="'Country'"
        [control]="form.Country"
        [alignRight]="showSelect || alignRight"
        [label]="showLabels ? 'Land' : ''"
        [options]="countriesObservable"
        [isReadOnly]="isReadOnly"
      ></app-select>
      <app-horizontal-text-input
        *ngIf="addressType === 'Province'"
        [id]="'Province'"
        [control]="form.Province"
        [type]="'address'"
        [href]="getMapsUrl()"
        [alignRight]="showSelect || alignRight"
        [label]="showLabels ? 'Provincie' : ''"
        [placeholder]="'Provincie'"
        [isReadOnly]="isReadOnly"
      ></app-horizontal-text-input>
      <app-horizontal-text-input
        *ngIf="addressType === 'Email'"
        [id]="'Email'"
        [control]="form.Email"
        [label]="showLabels ? 'E-mailadres' : ''"
        [type]="'email'"
        [alignRight]="showSelect || alignRight"
        [isReadOnly]="isReadOnly"
      ></app-horizontal-text-input>
    </ng-container>

    <div class="mb-3 row" *ngIf="showButtons && !isReadOnly">
      <div class="col-xs-6 text-end">
        <app-button [buttonClass]="'btn-link'" (click)="cancelEdit()">Annuleren</app-button>
        <app-button (click)="saveAddress()" [iconClass]="'fa-save'" [isSaving]="isSaving"
          >{{ name }} <span *ngIf="form.Id.value > 0">bewaren</span
          ><span *ngIf="form.Id.value == null">toevoegen</span></app-button
        >
      </div>
    </div>
  </div>
</form>
